import { DataTable } from "@/components/custom/DataTable";
import SearchFilter from "@/components/custom/SearchFilter";
import { useCarDetailsTableColumns } from "./columns";
import { CarDetailsTable } from "@/central-atoms/everest-fleet-pwa/types";

interface CarsAllocatedTableProps {
  data: CarDetailsTable[];
}

export default function CarsAllocatedTable({ data }: CarsAllocatedTableProps) {
  const columns = useCarDetailsTableColumns();
  return (
    <>
      <DataTable
        columns={columns}
        data={data}
        headerColor="bg-primary text-primary-foreground"
        alignment="center"
      />
    </>
  );
}
